<h2 mat-dialog-title class="av-section-title">{{ data.title | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">
    {{ 'backoffice.plans.prices.dialog.pair_hint' | translate }}
  </p>

  <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="price-dialog-shared-note">
    <mat-icon aria-hidden="true">info</mat-icon>
    <span>{{ 'backoffice.plans.prices.notice' | translate }}</span>
  </div>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="price-component">
      <span class="av-meta">
        {{ 'backoffice.plans.prices.dialog.component' | translate }}
      </span>
      <select
        id="price-component"
        class="av-field"
        formControlName="component_type"
        [attr.disabled]="isEdit ? '' : null"
      >
        @for (component of permittedComponents; track component.component_type) {
          <option [value]="component.component_type">
            {{ component.componentLabelKey | translate }} —
            {{ component.sharedProductNameKey | translate }}
          </option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="price-offer">
      <span class="av-meta">{{ 'backoffice.plans.prices.dialog.offer' | translate }}</span>
      <select id="price-offer" class="av-field" formControlName="offer_type">
        @for (option of offerOptions; track option) {
          <option [value]="option">{{ offerLabelKeys[option] | translate }}</option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="price-interval">
      <span class="av-meta">{{ 'backoffice.plans.prices.dialog.interval' | translate }}</span>
      <select id="price-interval" class="av-field" formControlName="billing_interval">
        @for (option of intervalOptions; track option) {
          <option [value]="option">{{ intervalLabelKeys[option] | translate }}</option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="price-currency">
      <span class="av-meta">{{ 'backoffice.plans.prices.dialog.currency' | translate }}</span>
      <input
        id="price-currency"
        type="text"
        class="av-field"
        maxlength="3"
        formControlName="currency"
      />
    </label>

    <label class="d-flex flex-column gap-1" for="price-amount">
      <span class="av-meta">{{ 'backoffice.plans.prices.dialog.unit_amount' | translate }}</span>
      <input
        id="price-amount"
        type="number"
        class="av-field"
        step="0.01"
        min="0.01"
        [attr.max]="amountMax"
        formControlName="unit_amount"
      />
    </label>

    <label class="d-flex align-items-center gap-2">
      <input type="checkbox" formControlName="is_active" />
      <span class="av-section-hint">
        {{ 'backoffice.plans.prices.dialog.active' | translate }}
      </span>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.plans.prices.dialog.confirm' | translate }}
  </button>
</mat-dialog-actions>
